export type Status = -1 | 0 | 1 | 2 | 3

export const StatusEnum = {
  LowImpact: 3,
  MediumImpact: 2,
  HighImpact: 1,
  Closed: 0,
  Unknown: -1,
} as const

export type StatusEnumType = (typeof StatusEnum)[keyof typeof StatusEnum]

export const StatusLabels: Record<StatusEnumType, string> = {
  [StatusEnum.Closed]: 'Closed',
  [StatusEnum.HighImpact]: 'High Impact',
  [StatusEnum.MediumImpact]: 'Medium Impact',
  [StatusEnum.LowImpact]: 'Low Impact',
  [StatusEnum.Unknown]: 'Unknown',
}
